import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';

export default class ProxyRoute extends PermittedRoute {
  permission = 'action.index';
}
